export const FACILITY_ITEM_TYPE_KPIS_SAVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFacility.FacilityKpiIndicatorsSaved";
